module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAAAN0lEQVRIDWNgGAXDPgQYYT78DwQwNjVoRiAAmcNEDcNGzRjcITCaigZ3/AwN142moqERTyPclQDQzQwK6eUosgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/data_menu.png
// module id = REoL
// module chunks = 1